<template>
    <div style="min-width:1334px">
        <el-carousel v-if="showBanner" height="460px" :autoplay-speed="4000" :interval="4000" v-model="banner" trigger="click" autoplay>
            <!-- <el-carousel-item>
                <div class="home_fts_box" @click="goFtsActive">
                    <img src='./img/home_fts_cont.png' class="home_fts_img"/>
                </div>
            </el-carousel-item> -->
            <el-carousel-item>
                <div class="first_banner">
                    <div class="first_width">
                        <div v-if="vipFlag == 1" class="first_left">
                            <p class="lp10">MEMBER</p>
                            <p class="vip_title">尊敬的{{ vipTitle }}</p>
                            <p class="vip_greetings">版权家为您提供一站式版权服务</p>
                            <p class="vip_desc">版权存证+取证+侵权监测+法律维权</p>
                            <p v-if="vipEndTime && vipEndTime!='' " class="vip_time">您的会员权益将于{{ vipEndTime }}日到期</p>
                            <div class="lpbaqck">
                                <!-- <a class="link_url" @click="showDialog03 = !0">VIP续费</a> -->
                                <a class="link_url" @click="goXu">VIP续费</a>
                            </div>
                        </div>

                        <div v-else class="first_left">
                            <p class="lp10">MEMBER</p>
                            <p class="lp11">开通会员</p>
                            <p class="lp12">尊享一站式版权服务</p>
                            <p class="lp13">版权存证+取证+侵权监测+法律维权</p>
                            <div class="lpbaqck">
                                <!--<a class="link_url" @click="govipPersonal">开通个人VIP</a>-->
                                <!--<a class="link_url" @click="govipEnterprise">开通企业VIP</a>-->
                                <a class="link_url" @click="govipVipIntroduce">开通VIP</a>
                            </div>
                        </div>


                        <img src="./../../images/first06.png" alt='版权登记'/>
                        <!-- <div class="imgs"></div> -->
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item v-for="item in list" :key="item.id">
                <a @click="goActivityUrl(item.partakeNumber,item.activityUrl)">
                    <div :style="'background-image: url(' + item.banner + ')'" class="first_banner activity_banner">
                    </div>
                </a>
            </el-carousel-item>
        </el-carousel>
        <div class="second_banner">
            <div class="second_width">
                <div class="sp10">
                    <div class="sp101">
                        <!-- <p>DCI</p>-->
                        <p>版权存证-直通互联网法院-司法认可的可信存证</p>
                    </div>
                </div>
                <router-link class="link_btn" to="/cunzheng.html">查看详情</router-link>
            </div>
			<!-- <div class="copyright_icon" @click="copyright_registration()" >
				<img class="copyright_img" src="./img/copyright.png" />
			</div>  -->
        </div>
        <mycapay @fatherModal="fatherModal" @updateVipData='updateVipData' mywidth='838' myheight="585"
                 myTitleheight="50" v-if="showDialog03"/>

    </div>
</template>

<script>
    import '@/plugins/element.js';
    import Cookies from "js-cookie";
    import mycapay from '@/views/vipClip/vip/lawcomponent/myczpay.vue';

    export default {
        name: 'first_banner',
        props: {
            refresh: {
                type: Number,
                default: 0
            }
        },
        components: {
            mycapay,
        },
        watch: {
            refresh: {
                immediate: true,
                handler: function () {
                    console.log('更新banner')
                    this.getVipMsg()
                }
            }
        },
        data() {
            return {
                banner: 0,
                showBanner: true,
                list: [],
                vipFlag: 0, //VIP类型 0未开通 1vip会员  2体验会员
                vipTitle: '',
                vipEndTime: '',
                showDialog03: !1, //续费会员弹框
                imgStyle: {
                    backgroundImage: `url(${require('./../../images/actbanner.png')})`,
                    backgroundSize: 'cover'
                },
            }
        },
        created() {
            // this.getVipMsg();
        },
        methods: {
			//跳转版权登记
			copyright_registration(){
				this.currPath=this.$route.path
				this.$router.push({
					path:'/huodong/zhishichanquanri.html'
				})
			},
            goFtsActive(){
				// this.currPath=this.$route.path
				this.$router.push({
					path:'/huodong/zhishichanquanri.html'
				})
			},
            goXu(){
                let userInfo = Cookies.get("userInfo");
                if (userInfo && userInfo != '') {
                    userInfo = JSON.parse(userInfo);
                    this.$router.push({
                        name: "openVip",
                        query:{
                            type:userInfo.medalName
                        },
                    });
                }else{
                    toast('请登录后再操作')
                    return false;
                }
            },
            govipPersonal() {
                window.open('/vipPersonal', '_blank')
            },
            govipEnterprise() {
                window.open('/vipEnterprise', '_blank')
            },
            govipVipIntroduce() {
                window.open('/huiyuan.html', '_blank')
            },
            goActivityUrl(number, activeUrl) {
                if (number > 0) {
                    window.open('/huodong/libao.html', '_blank')
                } else {
                    window.open(activeUrl, '_blank')
                }

            },
            goEvdenceActivity() {
                window.open('/evidenceActivity', '_blank')
            },

            /**********vip欢迎语设置********/
            getVipMsg() {
                let userInfo = Cookies.get("userInfo");
                if (userInfo && userInfo != '') {
                    userInfo = JSON.parse(userInfo);
                    let vipFlag = userInfo.vipFlag;
                    if (vipFlag == 1) {

                        //1.设置问候title
                        if (userInfo.accountType == 'person') {
                            this.vipTitle = '版权人' + userInfo.name
                        } else {
                            this.vipTitle = '企业会员'
                        }

                        //2.设置会员到期时间
                        let vipEndDate = userInfo.vipEndDate;
                        if (vipEndDate && vipEndDate != '') {
                            this.vipEndTime = vipEndDate.split(' ')[0];
                        } else {
                            this.vipEndTime = '';
                        }


                    }


                    this.vipFlag = vipFlag


                } else {
                    this.vipFlag = 0
                }
            },

            /**********会员续费弹框********/
            fatherModal() {
                this.showDialog03 = !1
            },

            /**********接收会员续费弹框续费成功后的回调********/
            updateVipData(data) {
                this.getVipMsg()
            },

        },
        mounted() {
            //注意：此处写死无用户token状态请求，如果后期针对此接口有登录信息要求，展示不同信息则要修改。
            //原因：用户状态失效时，banner组件不会再次请求接口。如后期修改，则在 getVipMsg中加入此段请求。
            this.getRequestWithNoToken('/activity/getAllByType/5').then(data => {
                console.log(data)
                let aa = data.result;
                for(let i in aa){
                    if(aa[i].activityUrl == "/huodong/zhishichanquanri.html"){
                        aa.splice(i, 1); 
                    }
                }
                this.list = aa.filter(item => item.status === 1);
                this.showBanner = true;
            }).catch(err => {
                this.showBanner = true;
            })
        }
    }
</script>

<style scoped lang="less">
.home_fts_box{
    width: 100%;
    height: 460px;
    cursor: pointer;
    background: url(./img/home_fts_bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .home_fts_img{
        width: 786px;
        height: 460px;
        display: block;
        margin: auto;
    }
}
    .first_banner {
        height: 460px;
        background: rgba(0, 0, 0, 1);

        &.activity_banner {
            background-position-x: center;
            background-size: auto 100%;
            background-repeat: no-repeat;
        }

        .first_width {
            width: 1334px;
            margin: 0 auto;
            display: flex;
            justify-content: flex-start;
            background: rgba(0, 0, 0, 1);

            .first_left {

                .vip_title {
                    font-size: 50px;
                    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 75px;
                    letter-spacing: 18px;
                    padding-top: 18px;
                }

                .vip_greetings {
                    font-size: 26px;
                    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 39px;
                    letter-spacing: 6px;
                    padding-top: 33px;
                }

                .vip_desc {
                    font-size: 20px;
                    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 30px;
                    letter-spacing: 3px;
                    padding-top: 18px;
                }

                .vip_time {
                    font-size: 16px;
                    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                    font-weight: 400;
                    color: rgba(232, 46, 49, 1);
                    line-height: 24px;
                    padding-top: 30px;
                }

                .lp10 {
                    height: 28px;
                    font-size: 20px;
                    font-weight: 300;
                    color: rgba(255, 255, 255, 1);
                    line-height: 28px;
                    letter-spacing: 2px;
                    margin-top: 35px;
                }

                .lp11 {
                    height: 70px;
                    font-size: 50px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 70px;
                    letter-spacing: 6px;
                    margin-top: 10px;
                    margin-bottom: 25px;
                }

                .lp12 {
                    width: 550px;
                    margin-right: 98px;
                    /*height:49px;*/
                    font-size: 35px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 49px;
                    letter-spacing: 15px;
                    margin-bottom: 23px;
                }

                .lp13 {
                    width: 550px;
                    font-size: 22px;
                    white-space: nowrap;
                    letter-spacing: 8px;
                    margin-right: 98px;
                    /*height:49px;*/
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 49px;
                    margin-bottom: 23px;
                }

                .lpbaqck {
                    background: url('./../../images/first08.png') 100% 100% no-repeat;
                    width: 550px;
                    height: 220px;

                    .link_url {
                        width: 138px;
                        height: 40px;
                        background: rgba(255, 216, 0, 1);
                        border-radius: 2px;
                        font-size: 14px;
                        font-weight: bold;
                        color: rgba(43, 33, 70, 1);
                        line-height: 40px;
                        margin-top: 27px;
                        margin-right: 40px;
                        cursor: pointer;
                        outline: none;
                        border: none;
                        display: inline-block;
                        text-align: center;
                    }
                }
            }

            img {
                width: 620px;
                height: 355px;
                overflow: hidden;
                display: block;
                object-fit: cover;
                margin-top: 30px;
            }
        }
    }

    .second_banner {
        height: 106px;
        background: rgba(255, 255, 255, 1);
        line-height: 106px;
        .second_width {
            width: 1334px;
            margin: 0 auto;
            height: 106px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgba(255, 255, 255, 1);

            .sp10 {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                img {
                    width: 44px;
                    height: 44px;
                    margin-right: 15px;
                }

                .sp101 {
                    display: flex;
                    flex-direction: column;

                    p {
                        /*width:360px;*/
                        height: 28px;
                        font-size: 20px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 1);
                        line-height: 28px;
                        letter-spacing: 2px;
                    }
                }
            }

            .link_btn {
                width: 138px;
                height: 40px;
                border-radius: 2px;
                background: #ffd800;
                border: 1px solid rgba(122, 122, 122, 1);
                font-size: 14px;
                font-weight: bold;
                color: #2b2146;
                line-height: 38px;
                margin-right: 40px;
                border: none;
                outline: none;
                cursor: pointer;
                text-align: center;
                // &:hover{
                //     background:#ffd800;
                //     border:none;
                //     color:#2b2146;
                // }
            }
        }
    }

    .short_video {
        background: #1F47C1;
        width: 100%;
        height: 460px;
        margin: 0 auto;
        box-sizing: border-box;

        .short_video_box {
            width: 1334px;
            height: 100%;
            margin: 0 auto;
            position: relative;
            z-index: 1;

            .short_video_box_left {
                padding-top: 76px;

                .short_video_title {
                    width: 465px;
                    height: 106px;
                    /*margin-top: 76px;*/
                    display: block;
                }

                .short_video_subtitle {
                    font-size: 40px;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 59px;
                    padding-top: 24px;
                }

                .short_video_btn {
                    display: flex;
                    align-items: center;
                    color: #FFFFFF;
                    font-size: 14px;
                    padding-top: 40px;

                    .short_video_btn_group {
                        display: flex;
                        padding-left: 8px;

                        .short_video_btn_item {
                            width: 116px;
                            height: 40px;
                            line-height: 40px;
                            box-sizing: border-box;
                            text-align: center;
                            border-radius: 21px;
                            border: 1px solid #0092FF;
                            margin-right: 24px;
                            cursor: pointer;

                            &:hover {
                                font-weight: bold;
                                background: linear-gradient(131deg, #0091FF 0%, #00C3FF 100%);
                                /*border: 0;*/
                            }
                        }
                    }

                    .short_video_btn_big{
                        width: 150px;
                        height: 40px;
                        line-height: 40px;
                        display: block;
                        box-sizing: border-box;
                        text-align: center;
                        border-radius: 21px;
                        border: 1px solid #0092FF;
                        margin-right: 24px;
                        background: linear-gradient(131deg, #0091FF 0%, #00C3FF 100%);
                        font-weight: bold;
                        color: #fff;

                        &:hover{
                            box-shadow: 0px 6px 10px 0px #002CB0;
                        }
                    }
                }

                .short_video_desc {
                    padding-top: 28px;
                    color: #FFFFFF;
                    font-size: 14px;
                    line-height: 20px;

                    .short_video_last {
                        padding-top: 6px;

                        .short_video_last_item {
                            padding-left: 25px;
                        }


                    }
                }
            }

            .short_video_circle {
                display: block;
                width: 373px;
                height: 67px;
                position: absolute;
                left: 0;
                bottom: 0;
                z-index: -1;
            }

            .short_video_pagoda {
                width: 1059px;
                height: 460px;
                position: absolute;
                right: 0;
                top: 0;
                z-index: -1;
            }
        }


    }

    /deep/.el-carousel__button{
        background-color: #8391a5;
        width: 16px;
        height: 3px;
        border-radius: 1px;
        transition: all .5s;
    }

    /deep/.el-carousel__indicator.is-active button{
        width: 24px;
    }
</style>